import {isAnyOf} from '@reduxjs/toolkit'

import {initOrderSheetByStorage} from '@web/actions/orderSheetInfo'
import {setMaximumRechargePoint} from '@web/actions/paymentMethod'
import {saveState} from '@web/actions/restoreState'
import {EnhancerOptions} from '@web/helpers/redux'
import {loggingAction} from '@web/middlewares/logger'
import {pageViewAction, uiEventAction} from '@web/middlewares/uiLogging'
import {checkInitOrderSheetDone} from '@web/slices/common/slice'

import {initOrderSheetByAPI} from '../../actions/familyPay'

const isFiltering = isAnyOf(
    uiEventAction,
    pageViewAction,
    loggingAction,
    initOrderSheetByAPI.fulfilled,
    initOrderSheetByAPI.rejected,
    initOrderSheetByStorage.fulfilled,
    initOrderSheetByStorage.rejected,
    setMaximumRechargePoint.rejected,
    setMaximumRechargePoint.fulfilled,
    checkInitOrderSheetDone,
    saveState,
)

const FamilyCheckoutSentryEnhancer: EnhancerOptions = {
    stateTransformer: () => {
        // 화이트 리스트 방식으로 필요한 값을 선택합니다.
        return {}
    },
    actionTransformer: (action) => {
        const actionType = action.type
        if (actionType.lastIndexOf('pending') > 0 || isFiltering(action)) {
            return null
        }
        return {
            ...action,
            payload: undefined,
        }
    },
}

export default FamilyCheckoutSentryEnhancer
